import { useState, useEffect } from 'react';
import { Plus, Pencil, Trash2 } from 'lucide-react';
import { getAdminLocations, createLocation, updateLocation, deleteLocation } from '../../services/api';
import toast from 'react-hot-toast';

const emptyLocation = { name: '', state: '', is_active: 1, sort_order: 0 };

export default function AdminLocations() {
  const [locs, setLocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyLocation);

  const load = () => {
    getAdminLocations().then(res => { setLocs(res.data); setLoading(false); }).catch(() => setLoading(false));
  };
  useEffect(load, []);

  const openCreate = () => { setEditing(null); setForm(emptyLocation); setShowModal(true); };
  const openEdit = (loc) => { setEditing(loc.id); setForm(loc); setShowModal(true); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) { await updateLocation(editing, form); toast.success('Location updated'); }
      else { await createLocation(form); toast.success('Location created'); }
      setShowModal(false);
      load();
    } catch { toast.error('Failed to save'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this location?')) return;
    try { await deleteLocation(id); toast.success('Deleted'); load(); }
    catch { toast.error('Failed to delete'); }
  };

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <>
      <div className="admin-table-wrap">
        <div className="admin-table-header">
          <h2>Manage Locations ({locs.length})</h2>
          <button className="btn-create" onClick={openCreate}><Plus size={18} /> Add Location</button>
        </div>
        {locs.length === 0 ? (
          <div className="empty-state"><h3>No locations</h3></div>
        ) : (
          <table className="admin-table">
            <thead><tr><th>City</th><th>State</th><th>Order</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {locs.map(l => (
                <tr key={l.id}>
                  <td style={{ fontWeight: 600 }}>{l.name}</td>
                  <td>{l.state || '-'}</td>
                  <td>{l.sort_order}</td>
                  <td><span className={`status-badge ${l.is_active == 1 ? 'status-published' : 'status-draft'}`}>{l.is_active == 1 ? 'active' : 'inactive'}</span></td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => openEdit(l)}><Pencil size={14} /> Edit</button>
                      <button className="btn-delete" onClick={() => handleDelete(l.id)}><Trash2 size={14} /> Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editing ? 'Edit Location' : 'Add Location'}</h2>
            <form onSubmit={handleSave}>
              <div className="form-row">
                <div className="form-group">
                  <label>City Name *</label>
                  <input type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required placeholder="e.g. Noida" />
                </div>
                <div className="form-group">
                  <label>State</label>
                  <input type="text" value={form.state} onChange={e => setForm({...form, state: e.target.value})} placeholder="e.g. Uttar Pradesh" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Sort Order</label>
                  <input type="number" value={form.sort_order} onChange={e => setForm({...form, sort_order: parseInt(e.target.value) || 0})} />
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <select value={form.is_active} onChange={e => setForm({...form, is_active: parseInt(e.target.value)})}>
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-cancel" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="submit" className="btn-save">{editing ? 'Update' : 'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
